import {
  FiChevronDown,
  FiFacebook,
  FiInstagram,
  FiMail,
  FiMap,
  FiMessageCircle,
  FiPhone,
} from 'react-icons/fi'
import { LiaBarsSolid } from 'react-icons/lia'
import { useNavigate } from 'react-router-dom'

import {
  ContainerSocialHeader,
  ContainerSocialHeaderMenu,
  ContainerSocialHeaderMenuAction,
  ContainerSocialHeaderMenuLogo,
  ContainerSocialHeaderMenuOptions,
  ContainerSocialHeaderMenuOptionsBox,
  ContainerSocialHeaderMenuActionMobile,
  ContainerSocialHeaderTop,
} from './styles'
import { AppConfigRoutes } from '../../../types/appConfig'
import useAppConfig from '../../../hooks/useAppConfig'
import { logFirebaseEvent } from '../../../services/firebase/analytics'

export type SocialHeaderMenuProps = {
  appLogo?: string
  appLogoDescription?: string

  menuList?: AppConfigRoutes[]

  actionButtonLabel?: string
  actionButtonOnClick?: () => void
}

export default function SocialHeaderMenu({
  appLogo,
  appLogoDescription,
  actionButtonLabel,
  actionButtonOnClick,
  menuList,
}: SocialHeaderMenuProps) {
  const navigate = useNavigate()
  const { appConfig } = useAppConfig()
  const {
    telephoneLabel: screenTelephoneLabel,
    email: screenEmail,
    locationLabel: screenLocationLabel,
  } = appConfig?.appConfig?.contacts ?? {}

  const handleANalyticsButtonClick = () => {
    logFirebaseEvent('button_click', {
      button_name: 'contact_us',
      screen_name: 'landing_page',
    })
  }

  return (
    <ContainerSocialHeader className="wlp-circular-header-menu-outer">
      <ContainerSocialHeaderTop>
        <div className="inner-header-top">
          <div className="box-icon-contact">
            <div className="box-icon-contact-option">
              <FiPhone />
              <div>{screenTelephoneLabel}</div>
            </div>
            <div className="box-icon-contact-option">
              <FiMail />
              <div>{screenEmail}</div>
            </div>
            <div className="box-icon-contact-option">
              <FiMap />
              <div>{screenLocationLabel}</div>
            </div>
          </div>
          <div className="box-icon-social-media">
            <FiFacebook />
            <FiInstagram />
            <FiMessageCircle />
          </div>
        </div>
      </ContainerSocialHeaderTop>
      <ContainerSocialHeaderMenu className="wlp-circular-header-menu">
        <ContainerSocialHeaderMenuLogo
          onClick={() => {
            logFirebaseEvent('home_logo', {
              screen_name: 'landing_page',
            })
            navigate('/')
          }}
        >
          <img
            src={appLogo}
            alt={appLogoDescription}
            width="100%"
            height="auto"
          />
          <h2>KFamily</h2>
        </ContainerSocialHeaderMenuLogo>
        <ContainerSocialHeaderMenuOptionsBox>
          {menuList?.map((itemMenu) => {
            return (
              <ContainerSocialHeaderMenuOptions
                key={`key-menu-internacional-hero-${itemMenu.id}`}
              >
                {itemMenu.name} <FiChevronDown />
              </ContainerSocialHeaderMenuOptions>
            )
          })}
        </ContainerSocialHeaderMenuOptionsBox>
        <ContainerSocialHeaderMenuAction
          onClick={() => {
            if (actionButtonOnClick !== undefined) {
              actionButtonOnClick()
            }
          }}
        >
          {actionButtonLabel ?? 'Entrar em contato'}
        </ContainerSocialHeaderMenuAction>
        <ContainerSocialHeaderMenuActionMobile
          onClick={() => {
            handleANalyticsButtonClick()

            if (actionButtonOnClick !== undefined) {
              actionButtonOnClick()
            }
          }}
        >
          <LiaBarsSolid />
        </ContainerSocialHeaderMenuActionMobile>
      </ContainerSocialHeaderMenu>
    </ContainerSocialHeader>
  )
}
